import type { AxiosError } from 'axios';
import translate from '@/lib/intl/translate';

export default function handleErrors(error: AxiosError) {
  let formattedError;
  let returnError = error;

  if (error.response && error.response.data) {
    returnError = error.response.data;
  }

  try {
    formattedError = error.toJSON();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Failed to format JSON', error);
    formattedError = translate('GENERIC_ERROR');
  }

  // eslint-disable-next-line no-console
  console.warn(formattedError);

  return returnError;
}
